export const listenbriefLink = {
  iosLink: 'https://ohjcz-alternate.app.link/RSCqugbSeMb', // https://share.bookey.app/RSCqugbSeMb
  androidLink: 'https://ohjcz-alternate.app.link/hdXcXOcSeMb', // https://share.bookey.app/hdXcXOcSeMb
};


export const mindfulLink = {
  iosLink: 'https://ohjcz-alternate.app.link/psBfhaDsaNb',
  androidLink: 'https://ohjcz-alternate.app.link/t8Kl2MDsaNb',
};

export const listenbriefMobileLink = {
  content: 'https://ohjcz-alternate.app.link/DAdyUPtSeMb',
};

export const mindfulMobileLink = {
  content: 'https://ohjcz-alternate.app.link/337rbrEsaNb',
};